import { createTheme } from "react-data-table-component";

createTheme('custom-dark', {
    text: {
      primary: '#fff',
    },
    background:{
      default: '#141b2d',      
    },
  }, 'dark');